/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host {
  display: inline-flex;
  outline: 2px solid transparent;
  outline-offset: 2px;
}
:host .button {
  background-color: transparent;
  border: none;
  margin: 0px;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  font-family: var(--calcite-font-family);
  font-size: var(--calcite-font-size-0);
  line-height: 1.25rem;
  outline-color: transparent;
  transition: background-color, block-size, border-color, box-shadow, color, inset-block-end, inset-block-start, inset-inline-end, inset-inline-start inset-size, opacity, outline-color, transform var(--calcite-animation-timing) ease-in-out 0s, outline 0s, outline-offset 0s;
  border-block-end: 2px solid transparent;
}

:host(:hover) .button,
:host(:focus) .button {
  background-color: var(--calcite-color-foreground-2);
}

:host(:focus) .button {
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            -2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
}

:host(:active) .button {
  background-color: var(--calcite-color-foreground-3);
  color: var(--calcite-color-text-1);
}

:host([active]) .button {
  border-color: var(--calcite-color-brand);
  color: var(--calcite-color-text-1);
  --calcite-icon-color: var(--calcite-color-brand);
}

.text-container {
  margin-block-start: 0.125rem;
  display: flex;
  flex-direction: column;
  padding-inline: 1rem;
  text-align: start;
}

calcite-avatar {
  padding-inline: 1rem;
}

calcite-avatar ~ .text-container {
  padding-inline-start: 0px;
}

.full-name {
  margin-inline-start: 0px;
  font-size: var(--calcite-font-size-0);
  font-weight: var(--calcite-font-weight-medium);
  color: var(--calcite-color-text-1);
}

.username {
  color: var(--calcite-color-text-2);
  font-size: var(--calcite-font-size--1);
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}